const translationsToggleButton = {
  'de-DE': {
    showMore: 'Mehr Entdecken',
    showLess: 'Weniger Entdecken',
  },
  'de-AT': {
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
  },
  'de-CH': {
    showMore: 'Mehr Entdecken',
    showLess: 'Weniger Entdecken',
  },
  'pt-PT': {
    showMore: 'Mostrar mais',
    showLess: 'Mostar menos',
  },
  'en-GB': {
    showMore: 'Discover more',
    showLess: 'Discover less',
  },
  es: {
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
  },
  fr: {
    showMore: 'Découvrir plus',
    showLess: 'Découvrez moins',
  },
  pl: {
    showMore: 'POKAŻ WIĘCEJ',
    showLess: 'POKAŻ MNIEJ',
  },
  it: {
    showMore: 'scopri di più',
    showLess: 'scopri di meno',
  },
  se: {
    showMore: 'Visa mer',
    showLess: 'Visa mindre',
  },
  nl: {
    showMore: 'Ontdek meer',
    showLess: 'Ontdek minder',
  },
};

module.exports = translationsToggleButton;
